import React from "react";

const ApplicantSignup = () => {
  return <h1>NEW APPLICANT</h1>;
};

export default ApplicantSignup;
